// 接口
export const apiObj = {
    menuList: '/auth/bdzl/menu/list',//系统菜单列表
    menuSave: '/auth/bdzl/menu/save',//菜单保存
    menuDetail: '/auth/bdzl/menu/edit',//菜单详情
    menuUpdate: '/auth/bdzl/menu/update',//菜单编辑
    menuDel: '/auth/bdzl/menu/remove',//菜单删除
    roleList: '/auth/bdzl/role/list',//角色列表
    roleDel: '/auth/bdzl/role/remove',//角色列表
    menuTree: "/auth/bdzl/menu/tree",//菜单权限列表
    roleSave: '/auth/bdzl/role/save',//菜单权限保存
    roleDetail: "/auth/bdzl/role/get",//菜单权限详情
    roleUpdate: "/auth/bdzl/role/update",//菜单权限编辑
    orgDeptTree: '/admin/bdzl/orgDept/Tree',//机构树

    orgList: '/admin/bdzl/org/list',//机构列表
    orgSave: '/admin/bdzl/org/save',//机构保存
    orgDetail: "/admin/bdzl/org/edit",//机构详情
    orgUpdate: "/admin/bdzl/org/update",//机构编辑
    orgDel: '/admin/bdzl/org/remove',//机构删除
	
	cusList: '/biz/bdzl/coopClient/list',//客商列表
	cusSave: '/biz/bdzl/coopClient/save',//客商保存
	cusDetail: "/biz/bdzl/coopClient/edit",//客商详情
	cusUpdate: "/biz/bdzl/coopClient/update",//客商编辑
	cusDel: '/biz/bdzl/coopClient/remove',//客商删除
	
	siteList: '/biz/bdzl/warehouse/list',//站点列表
	siteSave: '/biz/bdzl/warehouse/save',//站点保存
	siteDetail: "/biz/bdzl/warehouse/edit",//站点详情
	siteUpdate: "/biz/bdzl/warehouse/update",//站点编辑
	siteDel: '/biz/bdzl/warehouse/remove',//站点删除
	
	vehicleList: '/biz/bdzl/vehicle/list',//运力车辆列表
	vehicleSave: '/biz/bdzl/vehicle/save',//运力车辆保存
	vehicleDetail: "/biz/bdzl/vehicle/edit",//运力车辆详情
	vehicleUpdate: "/biz/bdzl/vehicle/update",//运力车辆编辑
	vehicleDel: '/biz/bdzl/vehicle/remove',//运力车辆删除

    vehList: '/biz/bdzl/vehInfo/list',//车辆列表
    vehSave: '/biz/bdzl/vehInfo/save',//车辆保存
    vehDetail: "/biz/bdzl/vehInfo/edit",//车辆详情
    vehUpdate: "/biz/bdzl/vehInfo/update",//车辆编辑
    vehDel: '/biz/bdzl/vehInfo/remove',//车辆删除
	vehGetHeadList: '/biz/bdzl/vehInfo/getVehHeadList',//选择牵引车辆
	vehGetTailList: '/biz/bdzl/vehInfo/getVehTailList',//选择挂车车辆
	
	driList: '/biz/bdzl/driInfo/list',//司机列表
	driSave: '/biz/bdzl/driInfo/save',//司机保存
	driDetail: "/biz/bdzl/driInfo/edit",//司机详情
	driUpdate: "/biz/bdzl/driInfo/update",//司机编辑
	driDel: '/biz/bdzl/driInfo/remove',//司机删除
	drigetList: '/biz/bdzl/driInfo/getDirList',//选择司机
	
	yyList: '/biz/bdzl/yayunInfo/list',//押运员列表
	yySave: '/biz/bdzl/yayunInfo/save',//押运员保存
	yyDetail: "/biz/bdzl/yayunInfo/edit",//押运员详情
	yyUpdate: "/biz/bdzl/yayunInfo/update",//押运员编辑
	yyDel: '/biz/bdzl/yayunInfo/remove',//押运员删除
	yygetList: '/biz/bdzl/yayunInfo/getYayunList',//选择押运员
	
	ordList: '/biz/bdzl/lngOrderInfo/list',//运单列表
	ordSave: 'biz/bdzl/lngOrderInfo/save',//运单保存
	ordDetail: "/biz/bdzl/lngOrderInfo/edit",//运单详情
	ordUpdate: "/biz/bdzl/lngOrderInfo/update",//运单编辑
	ordDel: '/biz/bdzl/lngOrderInfo/remove',//运单删除
	ordCancel: '/biz/bdzl/lngOrderInfo/cancel',//运单撤销
	ordStart: '/biz/bdzl/lngOrderInfo/orderStart',//运单派单
	ordgetList: '/biz/bdzl/driInfo/getDirList',//选择运单
	ordloadaudits: '/biz/bdzl/lngOrderInfo/orderLoadChk',//运单装货审核
	ordunloadaudits: '/biz/bdzl/lngOrderInfo/orderUnloadChk',//运单卸货审核
	ordexpensesaudits: '/biz/bdzl/lngOrderExpenses/examine',//运单费用审核
	orderFreightChk: '/biz/bdzl/lngOrderInfo/orderFreightChk',//运费审核
	orderFreightAntiChk: '/biz/bdzl/lngOrderInfo/orderFreightAntiChk',//运费反审核
	orderExamine: '/biz/bdzl/lngOrderInfo/orderExamine',//运单终审
	orderListCount: '/biz/bdzl/lngOrderInfo/getOrderCount',//运单状态数量
	orderLoadUpdate: '/biz/bdzl/lngOrderInfo/orderLoadUpdate',//运单装货修改
	orderUnloadUpdate: '/biz/bdzl/lngOrderInfo/orderUnloadUpdate',//运单卸货修改
	updateUnlLineInfo: '/biz/bdzl/lngOrderInfo/updateUnlLineInfo',//修改计划卸货点信息
	updateFreightInfo: '/biz/bdzl/lngOrderInfo/updateFreightInfo',//修改运单运价信息
	importOrderInfo: '/biz/bdzl/lngOrderInfo/importOrderInfo',//运单导入
	
	lineList: '/biz/bdzl/orderLineRec/listLine',//线路列表
	editLine: '/biz/bdzl/orderLineRec/editLine',//线路详情
	lineOrderList: '/biz/bdzl/orderLineRec/lineOrderList',//线路关联运单
	exportLineRec: '/biz/bdzl/orderLineRec/exportLineRec',//线路导出
	LineSetupdate: '/biz/bdzl/orderLineSet/update',//标准线路设置
	
	expensesOrderSave: '/biz/bdzl/expensesOrder/save',//添加费用
	expensesOrderUpdate: '/biz/bdzl/expensesOrder/update',//修改费用
	expensesOrderList: '/biz/bdzl/expensesOrder/list',//费用列表
	expensesOrderEdit: '/biz/bdzl/expensesOrder/edit',//费用详情
	expensesOrderRemove: '/biz/bdzl/expensesOrder/remove',//费用删除
	expensesOrderExamine: '/biz/bdzl/expensesOrder/examine',//费用审核
	expensesOrderWriteOff: '/biz/bdzl/expensesOrder/writeOff',//费用报销
	expensesOrderCount: '/biz/bdzl/expensesOrder/getOrderCount',//费用列表数量
	expensesOrderUserList: '/biz/bdzl/expensesOrder/getAdvanceUserList',//费用发起人列表
	expensesOrderUserVehList: '/biz/bdzl/lngOrderInfo/getDriverOrderCar',//费用发起人绑定车辆信息
	importExpenses: '/biz/bdzl/expensesOrder/importExpenses',//费用导入
	expensesOrderSum: '/biz/bdzl/expensesOrder/listOrderCount',//费用汇总数据
	
	getAllVehLocathion: '/biz/bdzl/vehInfo/getAllVehLocathion',//定位车辆数据
	getVehLocathion: '/biz/bdzl/vehInfo/getVehLocathion',//获取车辆实时数据
	getVehTraffic: '/biz/bdzl/vehInfo/getVehTraffic',//获取车辆轨迹数据
	getOrderTraffic: '/biz/bdzl/lngOrderInfo/getOrderTraffic',//获取运单轨迹数据
	
	reportOrderDetails: '/biz/bdzl/report/lngOrderDetails',//运单明细报表
	reportOrderexport: '/biz/bdzl/report/exportLngOrderDetails',//运单导出
	reportOrderSum: '/biz/bdzl/report/lngOrderDetailsCount',//运单报表汇总数据
	
	transLedgerByOrder: '/biz/bdzl/report/transLedgerByOrder',//台账单趟明细
	exportTransLedgerByOrder: '/biz/bdzl/report/exportTransLedgerByOrder',//台账单趟导出
	transLedgerByVehicle: '/biz/bdzl/report/transLedgerByVehicle',//台账单车月明细
	exportTransLedgerByVehicle: '/biz/bdzl/report/exportTransLedgerByVehicle',//台账单车月导出
	transLedgerByVehicleToDate: '/biz/bdzl/report/transLedgerByVehicleToDate',//台账单车时间段明细
	exportTransLedgerByVehicleToDate: '/biz/bdzl/report/exportTransLedgerByVehicleToDate',//台账单车时间段导出
	transLedgerByOrderSum: '/biz/bdzl/report/transLedgerByOrderCount',//台账单趟汇总数据
	
	homeStatistics: '/biz/bdzl/statistics/homeStatistics',//首页统计数据
	homeorderCount: '/biz/bdzl/statistics/orderCount',//首页数据走势
	
	vehMaintenanceProdlist: '/biz/bdzl/vehMaintenanceProd/list',//保养提醒列表
	vehMaintenanceProdedit: '/biz/bdzl/vehMaintenanceProd/edit',//保养提醒详情
	vehMaintenanceProdadd: '/biz/bdzl/vehMaintenanceProd/saveRoutine',//新建保养提醒
	vehMaintenanceProdupdate: '/biz/bdzl/vehMaintenanceProd/updateRoutine',//修改保养提醒
	vehMaintenanceProdremove: '/biz/bdzl/vehMaintenanceProd/removeRoutine',//删除保养提醒
	vehMaintenanceProdsaveTire: '/biz/bdzl/vehMaintenanceProd/saveTire',//新建轮胎保养提醒
	vehMaintenanceProdupdateTire: '/biz/bdzl/vehMaintenanceProd/updateTire',//修改轮胎保养提醒
	vehMaintenanceProdremoveTire: '/biz/bdzl/vehMaintenanceProd/removeTire',//删除轮胎保养提醒
	
	vehMaintenanceRecsave: '/biz/bdzl/vehMaintenanceRec/save',//新建保养记录
	vehMaintenanceRecupdate: '/biz/bdzl/vehMaintenanceRec/update',//修改保养记录
	vehMaintenanceRecremove: '/biz/bdzl/vehMaintenanceRec/remove',//删除保养记录
	vehMaintenanceReclist: '/biz/bdzl/vehMaintenanceRec/list',//保养记录列表
	vehMaintenanceRecedit: '/biz/bdzl/vehMaintenanceRec/edit',//保养记录详情
	
	vehRepairReclistStatistics: '/biz/bdzl/vehRepairRec/listStatistics',//维修统计列表
	vehRepairReclist: '/biz/bdzl/vehRepairRec/list',//维修记录列表
	vehRepairRecedit: '/biz/bdzl/vehRepairRec/edit',//维修记录详情
	vehRepairRecsave: '/biz/bdzl/vehRepairRec/save',//新增维修记录
	vehRepairRecupdate: '/biz/bdzl/vehRepairRec/update',//修改维修记录
	vehRepairRecremove: '/biz/bdzl/vehRepairRec/remove',//删除维修记录
	
	tableColumnGet: '/auth/bdzl/userTableColumn/myColumn',//获取显示列设置
	tableColumnUpdate: '/auth/bdzl/userTableColumn/update',//更新显示列设置

    userList: '/auth/bdzl/user/list',//系统用户列表
    userSave:'/auth/bdzl/user/save',//系统用户列表保存
    userDetail:"/auth/bdzl/user/edit",//系统用户详情
    userUpdate:'/auth/bdzl/user/update',//系统用户编辑
    userResetPassword:'auth/bdzl/user/resetPassword',//系统用户重置密码
	userChangePassword:'/auth/bdzl/user/changePassword',//用户修改密码
    userRemove:'/auth/bdzl/user/remove',//系统用户删除
    userIP:'/auth/bdzl/whiteIp/getInfo',//系统用户IP白名单 
    userIPSave:"/auth/bdzl/whiteIp/save",//系统用户IP白名单保存
    logList:"/admin/bdzl/log/list",//操作日志
    logDetail:"/admin/bdzl/log/edit",//操作日志详情
    xyList:"/admin/bdzl/agreement/list",//系统协议 
    agreementUpdate:'/admin/bdzl/agreement/update',//系统协议更新
	
}
